import { render, staticRenderFns } from "./CommentBox.vue?vue&type=template&id=0b4c4a05"
import script from "./CommentBox.vue?vue&type=script&lang=js"
export * from "./CommentBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports